import React from 'react'

function MoneyMarketFundWhy() {
  return (
    <div>


<p>Invest from as low as Kshs. 1,000</p>
<ul>
    <li>Earn Daily compounding interest (9-11%*)</li>
    <li>
Ease of withdrawal - Within 48 hrs straight to M-Pesa/Bank</li>



</ul>




    </div>
  )
}

export default MoneyMarketFundWhy